import { defineMessages } from "react-intl";

const labels = defineMessages({
    labourerName: {
        id: "labourer-field-label.labourerName",
        defaultMessage: "Labourer name",
        description: "Labourer name column label",
    },
    phone: {
        id: "labourer-field-label.phone",
        defaultMessage: "Contact number",
        description: "Labourer contact number column label",
    },
    email: {
        id: "labourer-field-label.email",
        defaultMessage: "Email address",
        description: "Labourer Email address column label",
    },
    skills: {
        id: "labourer-field-label.skills",
        defaultMessage: "Skillset",
        description: "Labourer Skillset column label",
    },
});

export const labourerFieldList = [
    {
        label: labels.labourerName,
        field: "labourerName",
        width: 200,
    },
    {
        label: labels.phone,
        field: "phone",
        width: 200,
    },
    {
        label: labels.email,
        field: "email",
        width: 200,
    },
    {
        label: labels.skills,
        field: "skillset",
        valueFormatter: (params) => {
            const skills = params.row.skills.results;
            return skills.map((skill) => skill.name).join(", ");
        },
        width: 600,
    },
];
